import React, { useEffect } from "react";
import TitlePages from "../../../layout/TitlePages";
import Breadcrumbs from "../../../layout/Breadcrumbs";
import { FileText, Download } from "lucide-react";
import "./FormatoSolicitud.css";

const Arco = () => {
  useEffect(() => {
    document.title = "Formato de solicitud de información / ARCO";
  }, []);

  return (
    <div className="formato-solicitud-page">
      <div className="margin-bottom-2">
        <Breadcrumbs
          path={[
            { label: "Transparencia", url: "/Transparencia" },
            { label: "Formato de solicitud de información / ARCO" },
          ]}
        />
        <TitlePages
          title="Transparencia"
          subTitle="Formato de solicitud de información / ARCO"
        />

        {/* Sección 1: Instructivo */}
        <section className="formato-section" aria-labelledby="heading-instructivo">
          <h2 id="heading-instructivo" className="formato-heading">
            Instructivo
          </h2>
          <div className="formato-heading-line" aria-hidden="true" />

          <ol className="formato-steps-list">
            <li className="formato-step-item">
              <span>
                Dar click en la liga para{" "}
                <strong className="formato-emphasis">DESCARGAR</strong> los
                formatos de solicitud de información/derecho ARCO.
              </span>
            </li>
            <li className="formato-step-item">
              <span>
                Capturar información en el formato correspondiente y guardar los
                cambios.
              </span>
            </li>
            <li className="formato-step-item">
              <span>
                Enviar <strong className="formato-emphasis">FORMATO(s)</strong>{" "}
                a la cuenta de correo:{" "}
                <a
                  href="mailto:transparencia@itetlax.org.mx"
                  className="formato-email-link"
                >
                  transparencia@itetlax.org.mx
                </a>
              </span>
            </li>
          </ol>
        </section>

        {/* Sección 2: Ligas para descargar */}
        <section className="formato-section" aria-labelledby="heading-ligas">
          <h2 id="heading-ligas" className="formato-heading">
            Ligas para descargar
          </h2>
          <div className="formato-heading-line" aria-hidden="true" />

          <div className="formato-cards-grid">
            {/* Tarjeta 1 */}
            <article className="formato-card">
              <div className="formato-card-left">
                <div className="formato-card-icon-circle" aria-hidden="true">
                  <FileText className="formato-card-icon" size={24} strokeWidth={1.8} />
                </div>
                <div className="formato-card-text">
                  <h3 className="formato-card-title">
                    Formato de solicitud de información
                  </h3>
                  <span className="formato-card-badge">Documento Word (.docx)</span>
                </div>
              </div>
              <a
                className="formato-download-btn"
                href="https://itetlax.org.mx/assets/word/transparencia/1.docx"
                download="formato_solicitud_informacion.docx"
                target="_blank"
                rel="noreferrer"
                aria-label="Descargar Formato de solicitud de información"
              >
                <Download size={18} strokeWidth={2} aria-hidden="true" />
                <span>Descargar</span>
              </a>
            </article>

            {/* Tarjeta 2 */}
            <article className="formato-card">
              <div className="formato-card-left">
                <div className="formato-card-icon-circle" aria-hidden="true">
                  <FileText className="formato-card-icon" size={24} strokeWidth={1.8} />
                </div>
                <div className="formato-card-text">
                  <h3 className="formato-card-title">
                    Formato de solicitud de ejercicio de Derechos ARCO
                  </h3>
                  <span className="formato-card-badge">Documento Word (.docx)</span>
                </div>
              </div>
              <a
                className="formato-download-btn"
                href="https://itetlax.org.mx/assets/word/transparencia/2.docx"
                download="formato_solicitud_derechos_arco.docx"
                target="_blank"
                rel="noreferrer"
                aria-label="Descargar Formato de solicitud de ejercicio de Derechos ARCO"
              >
                <Download size={18} strokeWidth={2} aria-hidden="true" />
                <span>Descargar</span>
              </a>
            </article>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Arco;
